/**
 * @module constants/teamMembers
 * @description Leadership team data for the home page team section.
 *
 * @extracted-from client/src/App.js (lines ~78–127, Phase 7)
 */

const TEAM_MEMBERS = [
  {
    id: 'naol',
    name: 'Naol Denko',
    role: 'Co-Founder & CEO',
    linkedin: 'https://www.linkedin.com/in/naol/',
    image: '/naol.jpg',
    imageAlt: 'Naol Denko',
    bioParagraphs: [
      'Co-Founder & CEO of CriticAI, an analysis tool for creatives that reached 4,300+ users in less than 7 months with strong retention. Featured on The Daily Bite, Top 20 on Product Hunt, and partnered with Sentient’s platform (3M+ distribution). Built a proprietary scoring algorithm and trend analysis system for creatives.',
      'Musician and builder: nominated for Breakthrough Artist and Hip-Hop Artist of the Year at the 2026 CSMAs; featured on CBC Radio 1; 1.2M+ TikTok views. Co-founded Sereen Health (peer-to-peer mental health support for musicians) and other startups including Characteris (recruiting assessment) and Fiable (biking rewards app). BA in Philosophy (Guelph); certifications in Music Business (Berklee), UX Design (Google), and Software Product Management (U of Alberta).',
    ],
  },
  {
    id: 'praveen',
    name: 'Praveen Akmeemana',
    role: 'Co-Founder & COO',
    linkedin: 'https://www.linkedin.com/in/praveen-akm/',
    image: '/praveen.jpeg',
    imageAlt: 'Praveen Akmeemana',
    bioParagraphs: [
      'Co-Founder & COO at CriticAI, gathering qualitative insights through surveys and direct collaboration with artists to shape how users receive and use AI-generated feedback. Supports user growth through marketing, outreach, and audience strategy.',
      'Research Lead at Sereen Health (UX research, usability testing, privacy and community guidelines). Research Technician and USRA Research Assistant at Ontario Veterinary College; Laboratory Assistant in vaccine development at University of Guelph. BSc in Microbiology with a minor in Molecular Genetics from the University of Guelph.',
    ],
  },
  {
    id: 'aaron',
    name: 'Aaron Jara',
    role: 'Co-Founder & CTO',
    linkedin: 'https://www.linkedin.com/in/aaron-jara1/',
    image: '/aaron.jpg',
    imageAlt: 'Professional headshot of Aaron Jara, Co-Founder & CTO, wearing a grey suit and blue tie',
    bioParagraphs: [
      'Co-Founder & CTO at CriticAI, leading system design and engineering for AI-driven audio and text analysis. Building backend pipelines, data infrastructure, and core product systems powering scoring, feedback generation, and platform reliability.',
      'Software Engineer Intern at Elevatr, contributing to production iOS development using SwiftUI and Supabase. Software Developer at YU Blueprint, building production database pipelines and full-stack features using TypeScript, Next.js, React, and PostgreSQL.',
    ],
  },
  {
    id: 'david',
    name: 'David Garrard',
    role: 'Tech Advisor',
    linkedin: 'https://www.linkedin.com/in/dgarrard/',
    image: '/david.jpeg',
    imageAlt: 'David Garrard',
    bioParagraphs: [
      '25+ years in tech leadership across AI, data engineering, and enterprise software. Has led full-stack teams through databases, ML, NLP, UX, mobile, APIs, and infrastructure, with a focus on user-centric design and data-driven product development.',
      'Former CTO of Last Call Analytics (analytics for beverage alcohol and cannabis), through acquisition by Ample Organics. Now leads FPdev.ai, FirePower Capital’s AI division, delivering custom technology to portfolio companies at accelerated timelines. Fractional CTO for AI-powered PropTech firms Konfidis Inc. and Keypr Inc., overseeing infrastructure that processes millions of properties.',
    ],
  },
];

export default TEAM_MEMBERS;
